import React, { useState, useEffect } from 'react';
import PieChart from '@rd-web-markets/shared/dist/dashboards/components/PieChart';
import projectReviewCompletionsService from './project_review_completions.service';
const statusMapping = {
  unstarted: 'not_started',
  begun_tech_interview_scheduled: 'in_progress',
  begun_tech_interview_completed: 'in_progress',
  begun_in_manager_qa: 'in_progress',
  begun_manager_qa_completed: 'in_progress',
  finished: 'completed',
  shortlisted_sampled: 'in_progress',
  scoping_scheduled: 'in_progress',
  scoping_completed: 'in_progress'
};
const BusinessProjectStatePieChart = _ref => {
  let {
    filteredBusinessUnits,
    selectedBUDashboard,
    labels = ['Completed', 'Not Started', 'In Progress'],
    selectedYears,
    companyId,
    selectedSubsidiaryCompanyIds,
    dashboard_raw_projects,
    ...props
  } = _ref;
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const buIds = selectedBUDashboard.map(bu => bu.business_unit_id ?? 0).join(',');
      const scIds = selectedSubsidiaryCompanyIds.join(',');
      const data = await projectReviewCompletionsService.all(companyId, buIds, scIds, selectedYears);
      setChartData(data);
    };
    fetchData();
  }, [companyId, selectedBUDashboard, selectedSubsidiaryCompanyIds, selectedYears]);
  const series = [chartData['completed'] || 0, chartData['not_started'] || 0, chartData['in_progress'] || 0];
  return /*#__PURE__*/React.createElement("div", {
    className: "p-2 dashboard-card"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center dashboard-regular-card-title"
  }, "Project Review Completion"), /*#__PURE__*/React.createElement(PieChart, {
    className: "pos-rel-top-10",
    labels: labels,
    series: series,
    label: 'Total Projects'
  }));
};
export default BusinessProjectStatePieChart;